module.exports = __webpack_public_path__ + "static/media/poly.bdc86d4b.jpg";